import React from 'react';
import { Grid, List, ListItemButton, ListItemIcon, ListItemText, Collapse, Box } from '@mui/material';
import { AddCircleOutline, MailOutline } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { GlobalMailEdit } from './GlobalMailEdit';
import { GlobalMailList } from './GlobalMailList';
import { useQueryClient } from '@tanstack/react-query';


enum GLOBALMAIL_VIEW {
  NEW = 'new',
  LIST = 'list',
}

type Props = {
  initialMails: any[];
};

export const GlobalMailView: React.FC<Props> = ({ initialMails }) => {
  const { view } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const resolvedView =
    view === GLOBALMAIL_VIEW.NEW ? GLOBALMAIL_VIEW.NEW : GLOBALMAIL_VIEW.LIST;

  const handleSendSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: ['globalmail'] });
    navigate('/admin/globalmail/list');
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={2}>
        <List>
          <ListItemButton onClick={() => navigate(`/admin/globalmail/new`)}>
            <ListItemIcon><AddCircleOutline /></ListItemIcon>
            <ListItemText primary="Neue Rundmail" />
          </ListItemButton>

          <ListItemButton onClick={() => navigate(`/admin/globalmail/list`)}>
            <ListItemIcon><MailOutline /></ListItemIcon>
            <ListItemText primary="Bisherige Rundmails" />
          </ListItemButton>
        </List>
      </Grid>

      <Grid item xs={10}>
        <Collapse in={resolvedView === GLOBALMAIL_VIEW.NEW}>
          <Box>
            <GlobalMailEdit
              currentId={-1}
              setCurrentId={() => {}}
              currentArray={initialMails}
              setCurrentArray={() => {}}
              setWasSaved={() => {}}
              setWasSavedSuccesfully={() => {}}
              onSendSuccess={handleSendSuccess}
            />
          </Box>
        </Collapse>

        <Collapse in={resolvedView === GLOBALMAIL_VIEW.LIST}>
          <GlobalMailList/>
        </Collapse>
      </Grid>
    </Grid>
  );
};
